<!-- Header -->
<div mat-dialog-title
	style="text-align: center; color: #A20000;"
	role="heading">
	Unsupported Browser
</div>

<!-- Body -->
<mat-dialog-content style="width: 580px">
	You are attempting to access SIS K-12 360 using an old version of Microsoft Internet Explorer that is not supported.
	<br>
	<br>
	A recent version of Google Chrome, Firefox, Microsoft Edge, or Apple Safari must be used.
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions>

	<!-- Right Buttons -->
	<div class="flex-footer-right">
		<tyl-button label="Close"
			image="Cancel.png"
			(clickEvent)="close()"></tyl-button>
	</div>
</mat-dialog-actions>